import { render, staticRenderFns } from "./detailInfo.vue?vue&type=template&id=98bc9a2a&scoped=true&"
import script from "./detailInfo.vue?vue&type=script&lang=js&"
export * from "./detailInfo.vue?vue&type=script&lang=js&"
import style0 from "./detailInfo.vue?vue&type=style&index=0&id=98bc9a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bc9a2a",
  null
  
)

export default component.exports